import { getWidget } from '@uvocore-front/utils';
import Loader from '../UI/loader';
import initCommonPage from './initCommonPage';
import Accordion from '../Accordion';

// run common page
const commonPage = document.getElementById('CommonPage');
if (commonPage) {
  getWidget({
    widgetLink: '/assets/js/commonPagesWidget.min.js',
    customLoader: Loader,
    insertLoaderTo: '#CommonPage',
    loaderPosition: 'center',
    fn: initCommonPage,
  });
}

if (document.querySelector('.toggle-list')) {
  /* eslint-disable no-unused-vars */
  const acc = new Accordion({
    itemsSelector: '.Accordion__item',
  });
  /* eslint-enable no-unused-vars */
}
